import React from "react";
import { useSelector } from "react-redux";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";
import PercentChanged from "../../../../components/percentChanged/percentChanged";

const FirstTimeRidesMonthToDate = () => {
  const { firstTimeRidesMTD, firstTimeRidesMTDRawDataLink, firstTimeRidesMTDChange } = useSelector(
    (state) => state.firstRiders.firstTimeRiders?.firstTimeRides
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <>
      <NumberDisplay
        value={firstTimeRidesMTD}
        url={firstTimeRidesMTDRawDataLink}
        disableAnimation={isUserQa}
      />
      <PercentChanged
        changeValue={firstTimeRidesMTDChange}
        toolTip="Percentage change from previous month"
        showBorder
      />
    </>
  );
};

export default FirstTimeRidesMonthToDate;
